import {CdkColumnDef} from '@angular/cdk/table';
import {Component, ElementRef, Input, OnChanges, OnInit, Optional, SimpleChanges, Renderer2 } from '@angular/core';
import {ValgSortable, ValgSortDir, ValgSortDirective, ValgSortFunc, ValgSortType,} from '../valg-sort.directive';
import {SvgIcon} from '@valg-shared/utils/svg-icon';
import {ColumnMetadata} from '@valg-shared/components/table/table/column-metadata';

@Component({
  selector: 'valg-sort-header',
  exportAs: 'valgSortHeader',
  templateUrl: './valg-sort-header.component.html',
})
export class ValgSortHeaderComponent
  implements OnInit, ValgSortable, OnChanges
{
  public id: string;
  public sortable = false;
  public dataType?: ValgSortType = undefined;
  public sortDirection: ValgSortDir = 'none';
  public sortIcon!: SvgIcon;
  public sortFunction?: ValgSortFunc;
  public sortDiscriminator?: string;

  @Input()
  public columnMetadata?: ColumnMetadata;
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    @Optional() public _sort: ValgSortDirective,
    @Optional()
    public _columnDef: CdkColumnDef
  ) {
    this.id = this._columnDef?.name ?? '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['columnMetadata']) {
      this.sortable = this.columnMetadata?.sortable ?? false;
      if (this.sortable) {
        this.sortDiscriminator = this.columnMetadata?.sortDiscriminator;
        this.dataType = this.columnMetadata?.sortDataType;
        this.sortFunction = this.columnMetadata?.sortFunction;
        this.sortDirection = this.columnMetadata?.defaultSort ?? 'none';
      }
    }
    this.changeSortIcon();
    this.setAccessibilitySort();
  }

  ngOnInit(): void {
    this._sort.register(this);
  }

  setAccessibilitySort(){
    let sorting = "none";
    if(this.sortDirection === 'asc' || this.sortDirection === 'desc'){
      sorting = this.sortDirection === "asc" ? "ascending" : "descending";
    }
    this.renderer.setAttribute(this.elementRef.nativeElement.parentNode, 'aria-sort', sorting);
  }

  changeSortIcon(): void {
    switch (this.sortDirection) {
      case 'asc':
        this.sortIcon = SvgIcon.SortArrowAsc;
        break;
      case 'desc':
        this.sortIcon = SvgIcon.SortArrowDesc;
        break;
      case 'none':
      default:
        this.sortIcon = SvgIcon.SortArrowInactive;
        break;
    }
  }

  handleClick(): void {
    if (!this.sortable) {
      return;
    }
    switch (this.sortDirection) {
      case 'asc':
        this.sortDirection = 'desc';
        break;
      case 'desc':
        this.sortDirection = 'none';
        break;
      case 'none':
      default:
        this.sortDirection = 'asc';
        break;
    }
    this.changeSortIcon();
    this._sort.sort(this);
    this.setAccessibilitySort();
  }

  reset(): void {
    this.sortDirection = 'none';
    this.changeSortIcon();
    this.setAccessibilitySort();
  }
}
